export interface IFormOperationOptions {
    /**
     * Отказ означает, что черновик мог остаться изменённым частично (каскад changes),
     * и форма строки блокирует применение до отмены сеанса. Отказ некритичной
     * операции только ждут — она ничего не успевает записать.
     * @default true
     */
    critical?: boolean;
}

interface IFormOperationTracker {
    track<T>(operation: () => Promise<T>, options?: IFormOperationOptions): Promise<T>;
}

// Привязка к control сохраняется при перерендерах RHF; обычные формы работают
// без трекера. Форма строки ждёт здесь в том числе changes своих скалярных полей.
const trackers = new WeakMap<object, IFormOperationTracker>();

export const registerFormOperationTracker = (methods: { control: object }, tracker: IFormOperationTracker) => {
    trackers.set(methods.control, tracker);
    return () => {
        trackers.delete(methods.control);
    };
};

export const trackFormOperation = <T>(
    methods: { control: object } | undefined,
    operation: () => Promise<T>,
    options?: IFormOperationOptions,
): Promise<T> => {
    const tracker = methods && trackers.get(methods.control);
    return tracker ? tracker.track(operation, options) : operation();
};

/** Вычисление, которое пишет результат только при успехе (формула Calc): форма
 *  строки его дожидается, но отказ применение не блокирует. */
export const trackFormCalculation = <T>(methods: { control: object } | undefined, operation: () => Promise<T>) =>
    trackFormOperation(methods, operation, { critical: false });
